var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs flex-nowrap"},_vm._l((_vm.types),function(ref){
var code = ref[0];
var name = ref[1];
return _c('base-tab',{key:code,attrs:{"value":code,"selected":_vm.value},on:{"selected":function($event){return _vm.$emit('change', $event)}}},[_vm._v(_vm._s(name)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }